const actions = {
	SET_DEPENDENT: "SET_DEPENDENT"
};

export default actions;
